module.exports = __webpack_public_path__ + "img/1sb-five-stars-boutique-star-unselected.884a891.svg";